// So earlier, I'd re-invented bilinear interpolation from first principles
// and implemented it procedurally. Realized it, went to wikipedia and:
// there's a better (algebraic) way!
//
// Basic problem: I have four values (0,1,2,3) that are positioned along
// two axes, and I want to  "mix" them to get an in-between value (x)
// at a specific position that lies between the four known values.
//
// 	Step 1: find a & b
//  0--a----1
// 	|       |
// 	|  x    |
// 	|       |
// 	2--b----3
//
// Step 2: find x
//  0--a----1
// 	|  |    |
// 	|  x    |
// 	|  |    |
// 	2--b----3
//
// how to do this? First, take the position of x on one axis, and linearly
// interpolate along that axis, between 0-1 & 2-3, to get a & b.
// Then you interpolate between *those* along the other axis to get x. 
//
// If we think of x's position as two percentages (vertical + horizontal)
// we get to use this lil' formula:
//
// https://en.wikipedia.org/wiki/Bilinear_interpolation#On_the_unit_square
//
// So! *This* function (unitSquareInterpolationFn) returns a function that
// takes those two percentages and gives the value at that location
//
// f(0,1)----f(1,1)
//   |   |     |
//   | f(x,y)  |
//   |   |     | 
// f(0,0)----f(1,0)
//
// We give unitSquareInterpolationFn the value of f() at (0,0), (1,0),
// (1,0), and (1,1) and get back a function than can interpolate the
// value of f() at any (x,y) where x and y are both between 0 and 1.

export default function unitSquareBilinearInterpolationFn( f_00, f_01, f_10, f_11 ) {

	return ( x, y ) => (
		( f_00 * ( 1 - x ) * ( 1 - y ) ) + 
		( f_01 * ( 1 - x ) * y ) +
		( f_10 * x * ( 1 - y ) ) + 
		( f_11 * x * y )
	);

}